import { __decorate, __metadata } from "tslib";
import { Component, Inject, Prop } from "vue-property-decorator";
import LvDrawerMenu, { SYM_LV_DRAWER_MENU } from "../drawer-menu/LvDrawerMenu.vue";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvDrawerMenuItem";
/**
 * An item of the drawer menu
 */
let LvDrawerMenuItem = class LvDrawerMenuItem extends UIComponent {
};
__decorate([
    Inject(SYM_LV_DRAWER_MENU),
    __metadata("design:type", LvDrawerMenu)
], LvDrawerMenuItem.prototype, "drawerMenu", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: () => false }),
    __metadata("design:type", Boolean)
], LvDrawerMenuItem.prototype, "active", void 0);
LvDrawerMenuItem = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvDrawerMenuItem);
export default LvDrawerMenuItem;
//# sourceMappingURL=script.js.map